import { IAuthRepository } from '../../domain/repositories/IAuthRepository';
import { UserDTO } from '../dto/UserDTO';
import { UserMapper } from '../mappers/UserMapper';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  user: UserDTO;
}

/**
 * Login Use Case
 * Handles user authentication with email and password
 */
export class LoginUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}

  async execute(request: LoginRequest): Promise<LoginResponse> {
    const user = await this.authRepository.login(request.email, request.password);

    return {
      user: UserMapper.toDTO(user),
    };
  }
}
